import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import staticData from '../../config/config';

export const useChangeLayoutModeStore = create()(
  devtools(() => ({
    rtlData: staticData.rtl,
    topMenu: staticData.topMenu,
    mode: staticData.mainTemplate,
    loading: false,
    rtlLoading: false,
    menuLoading: false,
    mainContentLoading: false,
    error: null,
  })),
);
